<script setup>
import { ref, onMounted } from 'vue';
import { get_terms, create_term, delete_term, update_term } from '@/services/terms';
import { getLowerAge } from '@/helper';

const taxonomy = 'age_group_int'
const isLoading = ref(true)
const terms = ref([])
onMounted(async ()=>{
  let response = await get_terms(taxonomy)
  terms.value = sortAgeGroup(response.result.data.data)
  isLoading.value = false
})

const age_group_form = ref({
  id: '',
  status: 'new',
  from: '',
  to: ''
})

function editTerm(index, termObj){
  age_group_form.value.to = parseAgeGroup(terms.value[index]).to
  age_group_form.value.from = parseAgeGroup(terms.value[index]).from
  age_group_form.value.status = 'edit'
  age_group_form.value.id = termObj.id
}

const isSubmitting = ref(false)
async function createAgeGroup(){
  isSubmitting.value = true
  const term = {
    name: `${age_group_form.value.from} yrs - ${age_group_form.value.to} yrs`,
    term_taxonomy_attributes:{
      taxonomy
    }
  }
  if (age_group_form.value.status == 'new'){
    let response = await create_term(term)
    Swal.fire({
      title: 'Added',
      text: 'Age group successfully added',
      icon: 'success'
    })
    let temp = [...terms.value]
    temp.push(response.result.data.data)
    terms.value = sortAgeGroup(temp)
    age_group_form.value.to = ''
    age_group_form.value.from = ''
  }else{
    let response = await update_term(age_group_form.value.id, term)
    let tempTerm = response.result.data.data
    terms.value = terms.value.map(term => {
      if (term.id == tempTerm.id){
        return tempTerm
      }else{
        return term
      }
    })
    age_group_form.value = {
      id: '',
      status: 'new',
      from: '',
      to: ''
    }
  }
  isSubmitting.value = false
}

function sortAgeGroup(response){
  response.sort((a, b) => getLowerAge(a.attributes.name) - getLowerAge(b.attributes.name));
  return response
}

function parseAgeGroup(termObj){
  const name = termObj.attributes.name
  const regex = /(\d+)\s*yr[s]?/g;
  const matches = name.match(regex);

  // Create an object with 'from' and 'to' properties
  return {
    from: parseInt(matches[0]),
    to: parseInt(matches[1]),
  };
}

async function deleteTerm(index, term_id){
  let response = await delete_term(term_id)
  if (response.error){
    Swal.fire({
      title: 'Error',
      html: response.result.error,
      icon: 'error'
    })
  }else{
    Swal.fire({
      title: 'Deleted',
      text: 'Age group successfully deleted',
      icon: 'success'
    })
    terms.value.splice(index, 1)
  }
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Interventions" title="Age Group" :mainRoute="{name: 'package-intervention-list'}"/>
    <!-- <template v-show="false"> -->

    <LoadingCard v-if="isLoading" />
    <template v-else>
      <!-- Page title -->
      <div class="d-flex align-items-center">
        <div>
          <h4 class="mb-0">Age Group</h4>
        </div>
      </div>

      <div class="row mt-3">
        <!-- Form -->
        <div class="col-4">
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="createAgeGroup()">
                <div class="row mb-3">
                  <label class="form-label" for="age_group_from">Age Group</label>
                  <div class="input-group">
                    <input 
                      class="form-control"
                      type="number" 
                      placeholder="From" 
                      required
                      aria-label="From"
                      v-model="age_group_form.from"
                    >
                    <span class="input-group-text">-</span>
                    <input 
                      class="form-control" 
                      type="number"
                      placeholder="To" 
                      aria-label="To"
                      v-model="age_group_form.to"
                      required
                    >
                  </div>
                </div>
                <button :disabled="isSubmitting" class="btn btn-light-success" type="submit">
                  <div v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <template v-else>
                    <template v-if="age_group_form.status == 'new'">
                      Add Age Group
                    </template>
                    <template v-else>
                      Update Age Group
                    </template>
                  </template>
                </button>
              </form>
            </div>
          </div>
        </div>

        <!-- List -->
        <div class="col-8 card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table user-table">
                <thead>
                  <tr>
                    <th>Description</th>
                    <!-- <th class="text-center">Count</th> -->
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody v-auto-animate>
                  <tr v-for="(termObj, index) in terms"
                    
                  >
                    <td :class="age_group_form.id == termObj.id ? 'bg-secondary-subtle text-dark': ''">
                      {{ termObj.attributes.name }}
                    </td>
                    <!-- <td class="text-center" :class="age_group_form.id == termObj.id ? 'bg-secondary-subtle text-dark': ''">10</td> -->
                    <td class="text-center" :class="age_group_form.id == termObj.id ? 'bg-secondary-subtle text-dark': ''">
                      <button @click="editTerm(index, termObj)" :disabled="age_group_form.id == termObj.id" class="me-2 btn rounded-circle p-2 btn-light-primary">
                        <vue-feather type="edit-2" size="1.15rem"/>
                      </button>
                      <button @click="deleteTerm(index, termObj.id)" class="btn rounded-circle p-2 btn-light-danger">
                        <vue-feather type="trash" size="1.15rem"/>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- </template>     -->
    <!-- <pdfViewer /> -->

  </div>
</template>